const removeTokenFromUrl = () => {
  const url = new URL(window.location.href);

  if (url.searchParams.has("token")) {
    url.searchParams.delete("token");
    window.history.replaceState({}, "", url);
  }
};

export {removeTokenFromUrl};
